{
  "de": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AFI": "Afar und Issa",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Ålandinseln",
      "ALB": "Albanien",
      "AND": "Andorra",
      "ANT": "Niederländische Antillen",
      "ARE": "Vereinigte Arabische Emirate",
      "ARG": "Argentinien",
      "ARM": "Armenien",
      "ASM": "Amerikanisch-Samoa",
      "ATA": "Antarktis",
      "ATB": "Britisches Antarktisterritorium",
      "ATF": "Französische Süd- und Antarktisgebiete",
      "ATG": "Antigua und Barbuda",
      "ATN": "Königin-Maud-Land",
      "AUS": "Australien",
      "AUT": "Österreich",
      "AZE": "Aserbaidschan",
      "BDI": "Burundi",
      "BEL": "Belgien",
      "BEN": "Benin",
      "BES": "Bonaire, Sint Eustatius und Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesch",
      "BGR": "Bulgarien",
      "BHR": "Bahrain",
      "BHS": "Bahamas",
      "BIH": "Bosnien und Herzegowina",
      "BLM": "Saint-Barthélemy",
      "BLR": "Belarus",
      "BLZ": "Belize",
      "BMU": "Bermuda",
      "BOL": "Bolivien",
      "BRA": "Brasilien",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhutan",
      "BUR": "Birma",
      "BVT": "Bouvetinsel",
      "BWA": "Botsuana",
      "BYS": "Belarus",
      "CAF": "Zentralafrikanische Republik",
      "CAN": "Kanada",
      "CCK": "Kokosinseln",
      "CHE": "Schweiz",
      "CHL": "Chile",
      "CHN": "China",
      "CIV": "Elfenbeinküste",
      "CMR": "Kamerun",
      "COD": "Kongo",
      "COG": "Kongo",
      "COK": "Cookinseln",
      "COL": "Kolumbien",
      "COM": "Komoren",
      "CPV": "Kap Verde",
      "CRI": "Costa Rica",
      "CSK": "Tschechoslowakei",
      "CTE": "Canton- und Enderburyinseln",
      "CUB": "Kuba",
      "CUW": "Curaçao",
      "CXR": "Weihnachtsinsel",
      "CYM": "Kaimaninseln",
      "CYP": "Zypern",
      "CZE": "Tschechien",
      "DDR": "Deutsche Demokratische Republik",
      "DEU": "Deutschland",
      "DHY": "Dahomey",
      "DJI": "Dschibuti",
      "DMA": "Dominica",
      "DNK": "Dänemark",
      "DOM": "Dominikanische Republik",
      "DZA": "Algerien",
      "ECU": "Ecuador",
      "EGY": "Ägypten",
      "ERI": "Eritrea",
      "ESH": "Westsahara",
      "ESP": "Spanien",
      "EST": "Estland",
      "ETH": "Äthiopien",
      "FIN": "Finnland",
      "FJI": "Fidschi",
      "FLK": "Falklandinseln (Malwinen)",
      "FRA": "Frankreich",
      "FRO": "Färöer",
      "FSM": "Mikronesien",
      "FXX": "Französisches Mutterland",
      "GAB": "Gabun",
      "GBR": "Vereinigtes Königreich",
      "GEL": "Gilbertinseln",
      "GEO": "Georgien",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinea",
      "GLP": "Guadeloupe",
      "GMB": "Gambia",
      "GNB": "Guinea-Bissau",
      "GNQ": "Äquatorialguinea",
      "GRC": "Griechenland",
      "GRD": "Grenada",
      "GRL": "Grönland",
      "GTM": "Guatemala",
      "GUF": "Französisch-Guayana",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hongkong",
      "HMD": "Heard- und McDonaldinseln",
      "HND": "Honduras",
      "HRV": "Kroatien",
      "HTI": "Haiti",
      "HUN": "Ungarn",
      "HVO": "Obervolta",
      "IDN": "Indonesien",
      "IMN": "Insel Man",
      "IND": "Indien",
      "IOT": "Britisches Territorium im Indischen Ozean",
      "IRL": "Irland",
      "IRN": "Iran",
      "IRQ": "Irak",
      "ISL": "Island",
      "ISR": "Israel",
      "ITA": "Italien",
      "JAM": "Jamaika",
      "JEY": "Jersey",
      "JOR": "Jordanien",
      "JPN": "Japan",
      "JTN": "Johnstoninsel",
      "KAZ": "Kasachstan",
      "KEN": "Kenia",
      "KGZ": "Kirgisistan",
      "KHM": "Kambodscha",
      "KIR": "Kiribati",
      "KNA": "St. Kitts und Nevis",
      "KOR": "Südkorea",
      "KWT": "Kuwait",
      "LAO": "Laos",
      "LBN": "Libanon",
      "LBR": "Liberia",
      "LBY": "Libyen",
      "LCA": "St. Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Litauen",
      "LUX": "Luxemburg",
      "LVA": "Lettland",
      "MAC": "Macau",
      "MAF": "St. Martin (französischer Teil)",
      "MAR": "Marokko",
      "MCO": "Monaco",
      "MDA": "Republik Moldau",
      "MDG": "Madagaskar",
      "MDV": "Malediven",
      "MEX": "Mexiko",
      "MHL": "Marshallinseln",
      "MID": "Midwayinseln",
      "MKD": "Mazedonien",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolei",
      "MNP": "Nördliche Marianen",
      "MOZ": "Mosambik",
      "MRT": "Mauretanien",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Malaysia",
      "MYT": "Mayotte",
      "NAM": "Namibia",
      "NCL": "Neukaledonien",
      "NER": "Niger",
      "NFK": "Norfolkinsel",
      "NGA": "Nigeria",
      "NHB": "Neue Hebriden",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Niederlande",
      "NOR": "Norwegen",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NTZ": "Neutrale Zone",
      "NZL": "Neuseeland",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCI": "Pazifikinseln (Treuhandgebiet)",
      "PCN": "Pitcairn",
      "PCZ": "Panamakanalzone",
      "PER": "Peru",
      "PHI": "Philippinen",
      "PHL": "Philippinen",
      "PLW": "Palau",
      "PNG": "Papua-Neuguinea",
      "POL": "Polen",
      "PRI": "Puerto Rico",
      "PRK": "Nordkorea",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Besetzte palästinensische Gebiete",
      "PUS": "Sonstige pazifische Inseln der Vereinigten Staaten",
      "PYF": "Französisch-Polynesien",
      "QAT": "Katar",
      "REU": "Réunion",
      "RHO": "Südrhodesien",
      "ROU": "Rumänien",
      "RUS": "Russland",
      "RWA": "Ruanda",
      "SAU": "Saudi-Arabien",
      "SCG": "Serbien und Montenegro",
      "SDN": "Sudan",
      "SEN": "Senegal",
      "SGP": "Singapur",
      "SGS": "Südgeorgien und die Südlichen Sandwichinseln",
      "SHN": "St. Helena, Ascension und Tristan da Cunha",
      "SJM": "Svalbard und Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Salomonen",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalia",
      "SPM": "Saint-Pierre und Miquelon",
      "SRB": "Serbien",
      "SSD": "Südsudan",
      "STP": "São Tomé und Príncipe",
      "SUN": "Sowjetunion",
      "SUR": "Suriname",
      "SVK": "Slowakei",
      "SVN": "Slowenien",
      "SWE": "Schweden",
      "SWZ": "Swasiland",
      "SXM": "Sint Maarten (niederländischer Teil)",
      "SYC": "Seychellen",
      "SYR": "Syrien",
      "TCA": "Turks- und Caicosinseln",
      "TCD": "Tschad",
      "TGO": "Togo",
      "THA": "Thailand",
      "TJK": "Tadschikistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "Osttimor",
      "TMP": "Portugiesisch-Timor",
      "TON": "Tonga",
      "TTO": "Trinidad und Tobago",
      "TUN": "Tunesien",
      "TUR": "Türkei",
      "TUV": "Tuvalu",
      "TWN": "Taiwan (Provinz Chinas)",
      "TZA": "Tansania",
      "UGA": "Uganda",
      "UKR": "Ukraine",
      "UMI": "Kleinere Amerikanische Überseeinseln",
      "URY": "Uruguay",
      "USA": "Vereinigte Staaten",
      "UZB": "Usbekistan",
      "VAT": "Vatikanstadt",
      "VCT": "St. Vincent und die Grenadinen",
      "VDR": "Nordvietnam",
      "VEN": "Venezuela",
      "VGB": "Britische Jungferninseln",
      "VIR": "Amerikanische Jungferninseln",
      "VNM": "Südvietnam",
      "VUT": "Vanuatu",
      "WAK": "Wakeinsel",
      "WLF": "Wallis und Futuna",
      "WSM": "Samoa",
      "XXX": "Unbekannt",
      "YEM": "Nordjemen",
      "YMD": "Südjemen",
      "YUG": "Jugoslawien",
      "ZAF": "Südafrika",
      "ZAR": "Zaire",
      "ZMB": "Sambia",
      "ZWE": "Simbabwe"
    }
  }
}
